import React from 'react'
import Layout from './Layout'

export default function DefaultLayout (props) {
  return (
    <Layout {...props} />
  )
}



// WEBPACK FOOTER //
// ./src/components/layout/DefaultLayout.jsx